import React from "react";
import styled from "styled-components";
import { determineClosestStepen } from "../../utils/determineClosestStepen";
import { useTranslation } from "react-i18next";

const OverviewContainer = styled.div`
  display: flex;
  flex-wrap: wrap; /* Allow sections to wrap to the next row */
  gap: 16px; /* Add some spacing between sections */
  margin-top: 20px;
`;

const OverviewSection = styled.div`
  flex: 1;
  min-width: calc(
    33.33% - 16px
  ); /* Set the width of each section to one-third of the container width */
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #e5fbe5;

  h2 {
    font-size: 18px;
    margin-bottom: 8px;
    font-weight: bold;
  }

  p {
    margin: 5px 0;
    span {
      margin-right: 10px;
    }
  }
`;

const Overview = ({ personalData }) => {
  const { t } = useTranslation()
  //const xo = Math.round((2 * personalData.footWidthLeft) / 3);
  //console.log(xo);
  //const mlaDescendingLevelLeft = (2 * personalData.footWidthLeft) / 15;
  //const mlaDescendingLevelRight = (2 * personalData.footWidthRight) / 15;
  const optimalnaDubinaLevo = ((2 / 3) * personalData.footWidthLeft).toFixed(2);
  const optimalnaDubinaDesno = ((2 / 3) * personalData.footWidthRight).toFixed(2);
  const visinaSvodaLevo = Math.round(optimalnaDubinaLevo * 0.4).toFixed(2);
  const visinaSvodaDesno = Math.round((optimalnaDubinaDesno * 0.4).toFixed(2))
  const fdxL = Math.round(optimalnaDubinaLevo - personalData.mlaDepthLeft);
  const fdxD = Math.round(optimalnaDubinaDesno - personalData.mlaDepthRight);
  const fdyL = Math.round(visinaSvodaLevo - personalData.mlaDepthLeft * 0.4)
  const fdyD = Math.round(visinaSvodaDesno - personalData.mlaDepthRight * 0.4);
  const procenatlevo = Math.round((fdyL / visinaSvodaLevo) * 100);
  //const procenatlevonoround = (fdyL / visinaSvodaLevo) * 100;
  const procenatDesno = Math.round((fdyD / visinaSvodaDesno) * 100);
  //const stepenLevo = Math.round((fdxL / optimalnaDubinaLevo) * 100)
  //const stepenDesno = Math.round((fdxD / optimalnaDubinaDesno) * 100)
  const stepenLevoNoRound = (fdxL / optimalnaDubinaLevo) * 100
  const stepenDesnoNoRound = (fdxD / optimalnaDubinaDesno) * 100
  const mlaEvelLeft = determineClosestStepen(stepenLevoNoRound);
  const mlaEvelRight = determineClosestStepen(stepenDesnoNoRound);
// console.log(procenatlevo,'levo')
// console.log(procenatlevonoround, 'levonoround')
// console.log(procenatDesno,'desno')
// console.log(procenatlevonoround, 'levonoround')
  return (
    <OverviewContainer>
      <OverviewSection>
        <h2>{t('leftFootMeasurement')}</h2>
        <p>
          <span>{t('footLength')}:</span>
          <span>{personalData.footLengthLeft} mm</span>
        </p>
        <p>
          <span>{t('footWidth')}:</span>
          <span>{personalData.footWidthLeft} mm</span>
        </p>
        <p>
          <span>{t('DepthOfFootArch')}:</span>
          <span>{personalData.mlaDepthLeft} mm</span>
        </p>
        <p>
          <span>{t('tendonPosition')}:</span>
          <span>{personalData.tendonPositionLeft} mm</span>
        </p>
        <p>
          <span>{t('legAlignement')}:</span>
          <span>{personalData.legAlignmentLeft}</span>
        </p>
      </OverviewSection>

      <OverviewSection>
        <h2>{t('rightFootMeasurement')}</h2>
        <p>
          <span>{t('footLength')}:</span>
          <span>{personalData.footLengthRight} mm</span>
        </p>
        <p>
          <span>{t('footWidth')}:</span>
          <span>{personalData.footWidthRight} mm</span>
        </p>
        <p>
          <span>{t('DepthOfFootArch')}:</span>
          <span>{personalData.mlaDepthRight} mm</span>
        </p>
        <p>
          <span>{t('tendonPosition')}:</span>
          <span>{personalData.tendonPositionRight} mm</span>
        </p>
        <p>
          <span>{t('legAlignement')}:</span>
          <span>{personalData.legAlignmentRight}</span>
        </p>
      </OverviewSection>
      {/* Leg length difference and footprint split */}
      <OverviewSection>
        <h2>{t('LegLengthDifference')} {t('and')} {t('FootprintSplit')}</h2>
        {personalData.legLengthDifference && (
          <p>
            <span>{t('LegLengthDifference')}:</span>
            <span>{personalData.legLengthDifference} mm</span>
          </p>
        )}
        {personalData.selectedLeg && (
          <p>
            <span>{t('selectedLeg')}: </span>
            <span>{t(personalData.selectedLeg)}</span>
          </p>
        )}
        <p>
          <span>{t('FootprintSplit')} ({t('left')}): </span>
          <span>{personalData.leftFootprintSplit ? t('yes') : t('no')}</span>
        </p>
        <p>
          <span>{t('FootprintSplit')} ({t('right')}): </span>
          <span>{personalData.rightFootprintSplit ? t('yes') : t('no')}</span>
        </p>
      </OverviewSection>
      <OverviewSection>
        <h2>{t('footParametersLeft')}</h2>
        <p>
          <span>{t('optimalMlaDepth')} (mm): </span>
          <span>{Math.round(optimalnaDubinaLevo)}mm</span>
        </p>
        <p>
          <span>{t('optimalMlaHeight')} (mm): </span>
          <span>{Math.round(visinaSvodaLevo)} mm</span>
        </p>
        <p>
          <span>FDx [mm] ({t('horizontalDisplacement')}): </span>
          <span>{Math.round(fdxL)}mm</span>
        </p>
        <p>
          <span>Fdy [mm] ({t('verticalDisplacement')}): </span>
          <span>
            {Math.round(visinaSvodaLevo - personalData.mlaDepthLeft * 0.4)}mm
          </span>
        </p>
        <p>
          <span>{t('mlaDescending')}: </span>
          <span>{procenatlevo}%</span>
        </p>
        {/* <p>
          <span>Y [mm] (visina svoda): </span>
          <span>{(personalData.mlaDepthLeft * 0.4).toFixed(2)} mm</span>
        </p> */}
        <p>
          <span>{t('mlaDescendingLevel')}: </span>
          <span>{`${mlaEvelLeft.stepen} (${mlaEvelLeft.percentage}%)`}</span>
        </p>
      </OverviewSection>
      <OverviewSection>
        <h2>{t('footParametersRight')}</h2>
        <p>
          <span>{t('optimalMlaDepth')} (mm):</span>
          <span>{Math.round(optimalnaDubinaDesno)}mm</span>
        </p>
        <p>
          <span>{t('optimalMlaHeight')} (mm):</span>
          <span>{Math.round(visinaSvodaDesno)} mm</span>
        </p>
        <p>
          <span>FDx [mm] ({t('horizontalDisplacement')}): </span>
          <span>{Math.round(fdxD)}mm</span>
        </p>
        <p>
          <span>Fdy [mm] ({t('verticalDisplacement')}): </span>
          <span>
            {Math.round(visinaSvodaDesno - personalData.mlaDepthRight * 0.4)}mm
          </span>
        </p>
        <p>
          <span>{t('mlaDescending')}: </span>
          <span>{procenatDesno}%</span>
        </p>
        <p>
          <span>{t('mlaDescendingLevel')}: </span>
          <span>{`${mlaEvelRight.stepen} (${mlaEvelRight.percentage}%)`}</span>
        </p>
      </OverviewSection>
    </OverviewContainer>
  );
};

export { Overview };
